// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/assets/fonts/Gilroy-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/assets/fonts/Gilroy-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/assets/fonts/Gilroy-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/assets/fonts/Gilroy-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/assets/fonts/NotoKufiArabic-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/assets/fonts/NotoKufiArabic-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/assets/fonts/NotoKufiArabic-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/assets/fonts/NotoKufiArabic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/assets/fonts/NotoKufiArabic-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/public/assets/fonts/NotoKufiArabic-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
    font-family: 'medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'semi-bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
    font-family: 'regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
    font-family: 'thin';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

@font-face {
    font-family: 'light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

* {
    scrollbar-color: var(--primary-accent) a64 transparent; /* thumb and track color */
    scrollbar-width: thin; /* "auto" or "thin"  */
}

@font-face {
    font-family: 'notokufi-bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face {
    font-family: 'notokufi-medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}

@font-face {
    font-family: 'notokufi-semi-bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}

@font-face {
    font-family: 'notokufi-regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
}

@font-face {
    font-family: 'notokufi-thin';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
}

@font-face {
    font-family: 'notokufi-light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
}

:root {
    --font-bold: 'bold';
    --font-medium: 'medium';
    --font-semi-bold: 'semi-bold';
    --font-regular: 'regular';
    --font-thin: 'thin';
    --font-light: 'light';

    --font-arabic-bold: 'notokufi-bold';
    --font-arabic-medium: 'notokufi-medium';
    --font-arabic-semi-bold: 'notokufi-semi-bold';
    --font-arabic-regular: 'notokufi-regular';
    --font-arabic-thin: 'notokufi-thin';
    --font-arabic-light: 'notokufi-light';
}

:root {
    --font-size-1: 8px;
    --font-size-2: 10px;
    --font-size-3: 11px;
    --font-size-4: 12px;
    --font-size-5: 13px;
    --font-size-6: 14px;
    --font-size-7: 15px;
    --font-size-8: 16px;
    --font-size-9: 17px;
    --font-size-10: 18px;
    --font-size-11: 19px;
    --font-size-12: 20px;
    --font-size-13: 22px;
    --font-size-14: 25px;
    --font-size-15: 40px;
    --font-size-16: 56px;
}

[data-lang='ar'] {
    --font-size-1: 6px;
    --font-size-2: 7px;
    --font-size-3: 8px;
    --font-size-4: 9px;
    --font-size-5: 10px;
    --font-size-6: 11px;
    --font-size-7: 12px;
    --font-size-8: 13px;
    --font-size-9: 14px;
    --font-size-10: 15px;
    --font-size-11: 16px;
    --font-size-12: 17px;
    --font-size-13: 18px;
    --font-size-14: 22px;
    --font-size-15: 36px;
    --font-size-16: 52px;
}

:root {
    --scale: 0.195;
}

select {
    appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/style/fonts.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,+DAAmE;AACvE;;AAEA;IACI,qBAAqB;IACrB,+DAAqE;AACzE;;AAEA;IACI,wBAAwB;IACxB,+DAAuE;AAC3E;;AAEA;IACI,sBAAsB;IACtB,+DAAsE;AAC1E;;AAEA;IACI,mBAAmB;IACnB,+DAAmE;AACvE;;AAEA;IACI,oBAAoB;IACpB,+DAAoE;AACxE;;AAEA;IACI,sDAAsD,EAAE,0BAA0B;IAClF,qBAAqB,EAAE,sBAAsB;AACjD;;AAEA;IACI,4BAA4B;IAC5B,+DAA2E;AAC/E;;AAEA;IACI,8BAA8B;IAC9B,+DAA6E;AACjF;;AAEA;IACI,iCAAiC;IACjC,+DAA+E;AACnF;;AAEA;IACI,+BAA+B;IAC/B,+DAA8E;AAClF;;AAEA;IACI,4BAA4B;IAC5B,gEAA2E;AAC/E;;AAEA;IACI,6BAA6B;IAC7B,gEAA4E;AAChF;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;;IAErB,mCAAmC;IACnC,uCAAuC;IACvC,6CAA6C;IAC7C,yCAAyC;IACzC,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IAEI,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: 'bold';\n    src: url('/public/assets/fonts/Gilroy-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'medium';\n    src: url('/public/assets/fonts/Gilroy-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'semi-bold';\n    src: url('/public/assets/fonts/Gilroy-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'regular';\n    src: url('/public/assets/fonts/Gilroy-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'thin';\n    src: url('/public/assets/fonts/Gilroy-Thin.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'light';\n    src: url('/public/assets/fonts/Gilroy-Light.ttf') format('truetype');\n}\n\n* {\n    scrollbar-color: var(--primary-accent) a64 transparent; /* thumb and track color */\n    scrollbar-width: thin; /* \"auto\" or \"thin\"  */\n}\n\n@font-face {\n    font-family: 'notokufi-bold';\n    src: url('/public/assets/fonts/NotoKufiArabic-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'notokufi-medium';\n    src: url('/public/assets/fonts/NotoKufiArabic-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'notokufi-semi-bold';\n    src: url('/public/assets/fonts/NotoKufiArabic-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'notokufi-regular';\n    src: url('/public/assets/fonts/NotoKufiArabic-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'notokufi-thin';\n    src: url('/public/assets/fonts/NotoKufiArabic-Thin.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'notokufi-light';\n    src: url('/public/assets/fonts/NotoKufiArabic-Light.ttf') format('truetype');\n}\n\n:root {\n    --font-bold: 'bold';\n    --font-medium: 'medium';\n    --font-semi-bold: 'semi-bold';\n    --font-regular: 'regular';\n    --font-thin: 'thin';\n    --font-light: 'light';\n\n    --font-arabic-bold: 'notokufi-bold';\n    --font-arabic-medium: 'notokufi-medium';\n    --font-arabic-semi-bold: 'notokufi-semi-bold';\n    --font-arabic-regular: 'notokufi-regular';\n    --font-arabic-thin: 'notokufi-thin';\n    --font-arabic-light: 'notokufi-light';\n}\n\n:root {\n    --font-size-1: 8px;\n    --font-size-2: 10px;\n    --font-size-3: 11px;\n    --font-size-4: 12px;\n    --font-size-5: 13px;\n    --font-size-6: 14px;\n    --font-size-7: 15px;\n    --font-size-8: 16px;\n    --font-size-9: 17px;\n    --font-size-10: 18px;\n    --font-size-11: 19px;\n    --font-size-12: 20px;\n    --font-size-13: 22px;\n    --font-size-14: 25px;\n    --font-size-15: 40px;\n    --font-size-16: 56px;\n}\n\n[data-lang='ar'] {\n    --font-size-1: 6px;\n    --font-size-2: 7px;\n    --font-size-3: 8px;\n    --font-size-4: 9px;\n    --font-size-5: 10px;\n    --font-size-6: 11px;\n    --font-size-7: 12px;\n    --font-size-8: 13px;\n    --font-size-9: 14px;\n    --font-size-10: 15px;\n    --font-size-11: 16px;\n    --font-size-12: 17px;\n    --font-size-13: 18px;\n    --font-size-14: 22px;\n    --font-size-15: 36px;\n    --font-size-16: 52px;\n}\n\n:root {\n    --scale: 0.195;\n}\n\nselect {\n    -webkit-appearance: none;\n    appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
